import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useGetTimeTrackingConsentQuery } from '@/core/api'
import { Role } from '@/core/types/shared'
import { isStaff } from '@/utils/type-guards'

export function useTimeTrackingAccess() {
  const authUser = useAppSelector(selectAuthUser)
  const isAdmin = authUser?.roles?.includes(Role.Admin) ?? false
  const isStaffMember = isStaff(authUser)

  const { data: consent, isLoading: isConsentLoading } = useGetTimeTrackingConsentQuery(undefined, {
    skip: !authUser || !isStaffMember,
  })

  const isEnabled = consent?.enabled ?? false

  return {
    authUser,
    isAdmin,
    isStaffMember,
    isEnabled,
    isConsentLoading,
    canAccessPage: isAdmin || isEnabled,
  }
}
